<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Users' : 'Deleted Users'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  @click="showCreateDialog = true"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/users/upload"
                >
                  <v-icon dark> mdi-upload </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3" v-if="user.roles[0].name == 'ADMIN'">
                  <v-autocomplete
                    solo
                    rounded
                    ref="position"
                    v-model="filter.position_id"
                    :items="positions"
                    label="Position"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-account"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="users.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="685px"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">First Name</th>
                      <th class="text-left">Middle Name</th>
                      <th class="text-left">Last Name</th>
                      <th class="text-left">User Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Position</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="users.length != 0">
                    <tr v-for="(user, i) in users" :key="`user${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="user.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>User is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="user.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>User is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ user.first_name || "" }}</td>
                      <td>{{ user.middle_name || "" }}</td>
                      <td>{{ user.last_name || "" }}</td>
                      <td>{{ user.user_name || "" }}</td>
                      <td>{{ user.email || "" }}</td>
                      <td>{{ user.phone || "" }}</td>
                      <td>
                        {{ user.position ? user.position.name : "" }}
                      </td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <!-- View KYC Button -->
                          <v-tooltip
                            bottom
                            v-if="
                              user.position_id == 1 || user.position_id == 2 || user.position_id == 3
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-1 mb-1"
                                fab
                                x-small
                                color="primary"
                                :to="`/users/${encryptIt(
                                  user.id
                                )}/user-kyc-details`"
                              >
                                <v-icon dark>mdi-content-duplicate</v-icon>
                              </v-btn>
                            </template>
                            <span>View KYC Details</span>
                          </v-tooltip>
                          <!-- Vehicle KYC Button - Only for position_id = 1 -->
                          <v-tooltip bottom v-if="user.position_id == 1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-1 mb-1"
                                fab
                                x-small
                                color="indigo"
                                @click="viewVehicleKYC(user.id)"
                              >
                                <v-icon dark>mdi-car-info</v-icon>
                              </v-btn>
                            </template>
                            <span>View Vehicle KYC Documents</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="askDelete(user)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this user</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                @click="openEditDialog(user)"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this user</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(user.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this user</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_user" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_user = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_user" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_user = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Delete confirmation -->
    <ConfirmationDialog
      :show.sync="deleteDialog"
      title="Delete User"
      message="This action cannot be undone. The user will lose access immediately."
      icon="mdi-account-remove"
      color="error"
      :loading="delete_user"
      @confirm="Delete_this(pendingDeleteId)"
    >
      <template v-slot:details>
        <v-alert v-if="pendingDeleteUser" outlined color="error" class="mt-3 mb-0" dense>
          <div class="d-flex align-center">
            <v-avatar color="error" size="36" class="mr-3">
              <span class="white--text font-weight-bold">{{ userInitials(pendingDeleteUser) }}</span>
            </v-avatar>
            <div>
              <div class="font-weight-bold">
                {{ pendingDeleteUser.first_name }} {{ pendingDeleteUser.last_name }}
              </div>
              <div class="text-caption grey--text text--darken-1">
                {{ pendingDeleteUser.email || pendingDeleteUser.phone || "" }}
                <span v-if="pendingDeleteUser.position"> · {{ pendingDeleteUser.position.name }}</span>
              </div>
            </div>
          </div>
        </v-alert>
      </template>
    </ConfirmationDialog>

    <!-- Add User -->
    <AppDialog
      :show.sync="showCreateDialog"
      max-width="900"
      persistent
      icon="mdi-account-plus"
      title="Add User"
      subtitle="Create a new user account"
    >
      <UserCreatePage
        v-if="showCreateDialog"
        embedded
        @created="onUserCreated"
        @close="showCreateDialog = false"
      />
    </AppDialog>

    <!-- Edit User -->
    <AppDialog
      :show.sync="showEditDialog"
      max-width="900"
      persistent
      icon="mdi-account-edit"
      title="Edit User"
      subtitle="Update this user's details"
    >
      <UserEditPage
        v-if="showEditDialog"
        embedded
        :user-id="editingId"
        @saved="onUserUpdated"
        @close="showEditDialog = false"
      />
    </AppDialog>
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import AppDialog from "@/components/AppDialog.vue";
import UserCreatePage from "./create.vue";
import UserEditPage from "./id.vue";
export default {
  name: "usersPage",
  components: { ConfirmationDialog, AppDialog, UserCreatePage, UserEditPage },
  data() {
    return {
      filter: {
        active: "",
        supervisor_id: "",
        role_id: "",
        position_id: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_user: false,
      restore_user: false,
      is_restored_user: false,
      deleteDialog: false,
      pendingDeleteId: null,
      pendingDeleteUser: null,
      delete_user: false,
      showCreateDialog: false,
      showEditDialog: false,
      editingId: null,
      users: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      positions: [
        {
          id: 0,
          text: "Select Position",
          value: "",
        },
      ],
      isLoading: false,
      isExcelloading: false,
      ExportUsers: [],
      Export_users: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Email: "email",
        Phone: "phone",
        Supervisor: "supervisor",
        "Is Active": "status",
      },
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=user`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.positions.forEach((position) => {
            this.positions.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=3" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&position_id=" +
        this.filter.position_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`users?${query}`)
        .then((response) => {
          this.users = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    askDelete(user) {
      this.pendingDeleteId = user.id;
      this.pendingDeleteUser = user;
      this.deleteDialog = true;
    },
    userInitials(user) {
      const first = (user.first_name || "").charAt(0);
      const last = (user.last_name || "").charAt(0);
      return (first + last).toUpperCase() || "?";
    },
    async Delete_this(id) {
      this.delete_user = true;
      await axios
        .post(`/users/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_user = true;
          this.deleteDialog = false;
          this.pendingDeleteUser = null;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // // window.location.href = "/auth/login";
        })
        .finally(() => {
          this.delete_user = false;
        });
    },
    onUserCreated() {
      this.showCreateDialog = false;
      this.page = 1;
      this.getData();
    },
    openEditDialog(user) {
      this.editingId = this.encryptIt(user.id);
      this.showEditDialog = true;
    },
    onUserUpdated() {
      this.showEditDialog = false;
      this.getData();
    },
    async addToExcelData() {
      this.isExcelLoading = true;
      this.title = "Company Lists";
      let Export_users = [];
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.filter.active +
        "&roleId=" +
        this.filter.role_id;
      Export_users = await axios.get(`users?${query}`);
      this.Export_users = Export_users.data.data;

      this.Export_users.forEach((user) => {
        this.ExportUsers.push({
          sr_no: user.sr_no,
          name: user.name ? user.name.toUpperCase() : "",
          email: user.email ? user.email.toUpperCase() : "",
          phone: user.phone ? user.phone : "",

          supervisor: user.supervisor_id
            ? user.supervisor.name.toUpperCase()
            : "",
          status: user.active == 1 ? "YES" : "NO",
        });
      });
      this.isExcelLoading = false;
    },
    async generateExcel() {
      this.isExcelloading = true;
      const params = {
        is_active: this.filter.is_active || "",
        position_id: this.filter.position_id || "",
        search_keyword: this.filter.search_keyword || "",
      };
      try {
        const response = await axios.get("/users/excel", {
          params,
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `users_${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
      }
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_user = true;
      await axios
        .post(`/users/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_user = false;
          this.is_restored_user = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // // window.location.href = "/auth/login";
        });
    },
    viewVehicleKYC(userId) {
      // Navigate to vehicle KYC documents page with user filter
      this.$router.push({
        path: '/vehicle-kyc-documents',
        query: { user_id: userId }
      });
    },
  },
};
</script>
